import { JournalDriver } from "../JournalDriver";
import { DataHeader, DataSource, Layout, Switch, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutWireHistory extends Layout {
    dataheaderGeneral: DataHeader;
    layoutJournalDriver: JournalDriver;
    sourceJournalDriver: DataSource;
    sourcePostedWire: DataSource;
    switchVoidflag: Switch;
    tabGLDistribution: Tab;
    tabGeneral: Tab;
    tabsetGeneral: Tabset;
    textboxChargeAmt: Textbox;
    textboxChargeCodeId: Textbox;
    textboxCheckAmount: Textbox;
    textboxCheckCode: Textbox;
    textboxCheckNumber: Textbox;
    textboxDeductCodeId: Textbox;
    textboxDescr: Textbox;
    textboxDriverFeeAmt: Textbox;
    textboxDriverId: Textbox;
    textboxFuelCardId: Textbox;
    textboxIfuelQuikqAssetId: Textbox;
    textboxMovementId: Textbox;
    textboxOrderId: Textbox;
    textboxPayeeId: Textbox;
    textboxServiceCharge: Textbox;
    textboxSubaccountId: Textbox;
    textboxTransDateTime: Textbox;
    textboxUserId: Textbox;
    textboxVoidDate: Textbox;
    textboxWireContractTch: Textbox;
    textboxWirecodeId: Textbox;
}
